import { FC } from 'react';
import { cn } from '@/shared/lib';
import { deltaClass, deltaText } from '../utils';

type Props = {
  value: number | null;
  className?: string;
};

/**
 * Текстовое отображение дельты/отклонения со стрелкой направления и цветом.
 * Используется в мини-отчёте консультанта.
 */
export const DeltaValue: FC<Props> = ({ value, className }) => (
  <span className={cn(deltaClass(value), className)}>{deltaText(value)}</span>
);
